import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { rtkBaseQuery } from '../helpers/rtkquery';

export const workCalendarApi = createApi({
  reducerPath: 'workCalendarApi',
  baseQuery: rtkBaseQuery('/staff/WorkCalendar'),
  tagTypes: ['WorkCalendars', 'WorkCalendar'],
  endpoints: (builder) => ({
    getAllWorkCalendars: builder.query({
      query: ({ year, month }) => `/GetAll?year=${year}&month=${month}`,
      providesTags: ['WorkCalendars'],
    }),
    getWorkCalendars: builder.query({
      query: (id) => `/GetById?id=${id}`,
      providesTags: ['WorkCalendar'],
    }),
    updateCalendarWorkDayHour: builder.mutation({
      query: (body) => ({
        url: 'Update',
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['WorkCalendars'],
    }),
    deleteCalendarWorkDayHour: builder.mutation({
      query: (id) => ({
        url: `Delete?id=${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['WorkCalendars'],
    }),
    createCalendarMonthYear: builder.mutation({
      query: (body) => ({
        url: `Create`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['WorkCalendars'],
    }),
  }),
});
export const {
  useGetAllWorkCalendarsQuery,
  useGetWorkCalendarsQuery,
  useUpdateCalendarWorkDayHourMutation,
  useDeleteCalendarWorkDayHourMutation,
  useCreateCalendarMonthYearMutation,
} = workCalendarApi;
